import { Component, OnInit, Output, EventEmitter, ViewChild, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DemoService } from '../../../shared/demo.service';
import { SelectionModel } from '@angular/cdk/collections';
import { CommonFilter } from 'src/app/shared/models/Common/common-filter';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { getDateValue, iterateAndWait } from 'lib/common/utils';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-vqt',
  templateUrl: './vqt.component.html',
  //styleUrls: ['./vqt.component.scss']
  styleUrls: ['../vquad/vquad.component.scss']
})
export class VQTComponent implements OnInit, AfterViewInit, OnDestroy {

  selectedRow: string;
  baseUrl: string;
  title: string;
  staticScreen = true;
  isLoading = false;
  url: string;
  currentPage: number;
  // MatPaginator Inputs
  length = 100;
  pageSize = 20;
  pageSizeOptions: number[] = [1, 10, 25, 100];
  pageIndex = 0;

  pageEvent: PageEvent;  // MatPaginator Output
  private commonFilter: CommonFilter;
  dataSource = new MatTableDataSource<any>([]);//[];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  centralIPsForm: FormGroup;
  centralIPsList = [];
  vqtID: number = 0;

  @Output() childTitleEvent = new EventEmitter();

  columnsToDisplay = ['NodeIP_Abs', 'NodeVersion_Abs', 'NodeTimestamp_Abs', 'CentralIP_Abs', 'TestName_Abs', 'VqtNodeStatus_Abs', 'select'];

  GetCentralIPLabel(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "Primary IP" : (CentralIPIndex_Abs == "1" ? "Secondary IPs" : "");
  }
  GetCentralIPInput(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "Primary IP" : "Secondary IP" + CentralIPIndex_Abs;
  }
  GetCentralIPLabelClass(CentralIPIndex_Abs) {

    return CentralIPIndex_Abs == "0" ? "PrimaryIPNew" : (CentralIPIndex_Abs == "1" ? "SecondaryIPNew" : "");
  }

  //mySubscription: any;
  AutoRefreshInfo: any;
  interval;
  private subscriptions: Subscription[] = [];

  constructor(private commonFilterService: CommonFilterService, private http: HttpClient, private demoService: DemoService, private dialog: MatDialog, private _formBuilder: FormBuilder, private router: Router) {
    this.baseUrl = environment.urlAddress + '/api/';

    this.commonFilterService.setNonFiltersScreen(true);

    this.centralIPsForm = this._formBuilder.group({
      dummyCentralIPsArray: this._formBuilder.array(this.centralIPsList)
    });

    //Do Refresh
    const _broadSubRefresh = this.commonFilterService.componentMethodCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        //console.log(res)
        this.LoadNSVQTData();
      }
    );
    this.subscriptions.push(_broadSubRefresh);

    //Do Auto-refresh - start/stop
    const _broadSubAutoRefresh = this.commonFilterService.componentMethodWithArgCalled$.subscribe(
      //() => {
      //  alert('(Component2) Method called!');
      //}

      res => {
        this.AutoRefreshInfo = res;
        //console.log(res)
        if (this.AutoRefreshInfo.AutoRefStop) {
          if (this.interval) {
            clearInterval(this.interval);
          }
        }
        else {
          this.interval = setInterval(() => {
            //console.log(this.AutoRefreshInfo.AutoRefStop);

            this.LoadNSVQTData();
          }, this.AutoRefreshInfo.AutoRefSelected);
        }
      }
    );
    this.subscriptions.push(_broadSubAutoRefresh);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
  //ngOnDestroy() {
  //  if (this.mySubscription) {
  //    this.mySubscription.unsubscribe();
  //  }
  //}
  ngAfterViewInit() {
    //setTimeout(() => this.dataSource.paginator = this.paginator);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  get dummyCentralIPsArray(): FormArray {
    return this.centralIPsForm.get('dummyCentralIPsArray') as FormArray;
  }

  OnReloadRoute() {
    this.router.navigateByUrl('statistics/nsvqt');
  }
  ngOnInit() {

    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //};
    //this.mySubscription = this.router.events.subscribe((event) => {
    //  if (event instanceof NavigationEnd) {
    //    // Trick the Router into believing it's last link wasn't previously loaded
    //    this.router.navigated = false;

    //    // if you need to scroll back to top, here is the right place
    //    window.scrollTo(0, 0);
    //  }
    //});

    this.LoadNSVQTData();
  }

  @Input() StatusVqtID: number = 0;
  LoadNSVQTData(event?: PageEvent) {
    this.isLoading = true;
    this.commonFilter = new CommonFilter();
    if (event != undefined) {

      this.currentPage = +event.pageIndex + +1;
      this.url = this.baseUrl + 'NwStat_VQT/GetAllNwStat_VQT';
      this.commonFilter.PerPage = event.pageSize.toString();
      this.commonFilter.PageNumber = this.currentPage.toString();

    } else {
      this.url = this.baseUrl + 'NwStat_VQT/GetAllNwStat_VQT';
      this.commonFilter.PerPage = this.pageSize.toString();
      this.commonFilter.PageNumber = "1";
    }
    //console.log(this.StatusVqtID)
    if (this.StatusVqtID != 0) {
      this.url = this.baseUrl + 'NwStat_VQuad/GetAllNwStat_VQTByID';
      this.commonFilter.ResultOrFileType = this.StatusVqtID;
    }

    this.GetAllData(this.commonFilter).subscribe((res: any) => {
      //console.log(res)
      if (res !== 'null') {
        let rows: any[] = JSON.parse(res) as any[];
        this.length = rows.length;
        this.dataSource.data = rows;
      }
      this.isLoading = false;
    },
      err => {
        this.isLoading = false;
      });

    return event;
  }

  parentEvent(title) {
    this.title = title;
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  GetAllData(commFilter: CommonFilter) {
     
    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, commFilter, options);
  }

  ///////////////////// checkbox selection
  selection = new SelectionModel<any>(true, []);

  //** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data != null ? this.dataSource.data.length : 0;
    return numSelected === numRows;
  }

  //** Selects all rows if they are not all selected; otherwise clear selection. */
  delButton: boolean;
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
    this.delbuttonSet(1);
  }
  delbuttonSet(type, row?) {
    if (type == 2)
      this.selection.toggle(row);

    if (this.selection.selected.length > 0)
      this.delButton = true;
    else
      this.delButton = false;
  }

  //** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }


  DeleteNSVQT(rowData?: any) {
    this.selectedRow = '';
    if (rowData)
      this.selectedRow += rowData.ID_Abs + ',';
    //this.dataSource.data.filter((value, key) => {
    //  if (this.selection.isSelected(value)) {
    //    
    //    this.selectedRow = this.selectedRow + value.ID_Abs + ',';
    //  }
    //});

    if (this.selectedRow != '') {

      const dailogConfig = new MatDialogConfig();
      dailogConfig.disableClose = true;
      dailogConfig.autoFocus = true;
      // dailogConfig.restoreFocus = true;
      dailogConfig.width = "40%";
      dailogConfig.data = { title: "Confirm Action", message: "Are you sure, you want to delete selected records?" };

      this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
        if (dialogResult) {
          this.DeleteVQTData(this.selectedRow).subscribe((res: any) => {
            this.LoadNSVQTData();
          });
        }
      });

      //if (confirm("Are you sure, you want to delete selected records?")) {
      //  this.DeleteMobileData(this.selectedRow).subscribe((res: any) => {
      //    this.LoadNSMobileData();
      //  });
      //}
    }

  }

  DeleteVQTData(nsVQTIDs: string) {
    this.url = this.baseUrl + 'NwStat_VQT/DeleteVQTByID?nsVQTIDs=' + nsVQTIDs;

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);
  }
  ///////////////////////////////////// end checkbox


  //Edit Node network info
  isEditable = {};
  EditRow(rowData: any, rowIndex) {
    if (this.prevRowIndex === -1) {
      this.prevRowData = rowData;
      this.prevRowIndex = rowIndex;
    }
    else {
      this.UndoRow(this.prevRowData, this.prevRowIndex);
      this.prevRowData = null;
      this.prevRowIndex = -1;
    }
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    this.vqtID = rowData.ID_Abs;

    this.centralIPsList = [];
    let cntIPs = 0;
    for (const key in rowData.CentralIP_Abs) {
      if (rowData.CentralIP_Abs[key] !== 'null')
        this.centralIPsList.push(rowData.CentralIP_Abs[key]);
      else
        this.centralIPsList.push("");
      cntIPs++;
    }
    for (var i = cntIPs; i < 4; i++)
      this.centralIPsList.push("");

    // if receiving data at a later point, use below instead
    this.centralIPsForm.setControl('dummyCentralIPsArray', this._formBuilder.array(this.centralIPsList));

    //this.dataSource = this.dataSource.filter((value, key) => {
    //  if (value.ID_Abs == rowData) {
    //    this.editRow = true;
    //  }
    //  else
    //    this.editRow = false;
    //  return true;
    //});
  }

  //Update node info in DB for DataImport to send 
  UpdateRow(rowData: any, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    //console.log(rowData);
    this.vqtID = 0;

    //https://stackoverflow.com/questions/15877362/declare-and-initialize-a-dictionary-in-typescript
    //https://stackoverflow.com/a/45157258 - Not needed but can be used in array as number type key and value
    let newCentralIPList: { [id: number]: string; } = {};//[];
    for (var i = 0; i < 4; i++)
      newCentralIPList[i] = this.dummyCentralIPsArray.value[i];//this.centralIPsList[i];

    rowData.CentralIP_Abs = newCentralIPList;
    //console.log(rowData.CentralIP_Abs)
    this.UpdateVQTData(rowData).subscribe((res: any) => {
    });

    //this.dataSource = this.dataSource.filter((value, key) => {
    //  if (value.ID_Abs == rowData.ID_Abs) {
    //    value.ID_Abs = rowData.ID_Abs;
    //    value.NodeAlias_Abs = rowData.NodeAlias_Abs;
    //    value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
    //    value.GPS_Long_Abs = rowData.GPS_Long_Abs;
    //    value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
    //    value.CentralIP_Abs = rowData.CentralIP_Abs;
    //    value.TestName_Abs = rowData.TestName_Abs;
    //  }
    //  return true;
    //});
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false; this.OnReloadRoute(); }, 3000); 
  }
  //change disconnected node to OOS
  changeToOOSRow(rowData: any) {//, rowIndex) {

    const dailogConfig = new MatDialogConfig();
    dailogConfig.disableClose = true;
    dailogConfig.autoFocus = true;
    // dailogConfig.restoreFocus = true;
    dailogConfig.width = "40%";
    dailogConfig.data = { title: "Confirm Action", message: "Are you sure you want to change status to Out of Service?" };

    this.dialog.open(ConfirmDialogComponent, dailogConfig).afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        //this.isEditable[rowIndex] = !this.isEditable[rowIndex];
        // console.log(rowData);
        this.vqtID = 0;

        rowData.NodeStatus_Abs = 1;

        this.UpdateOOSVQTData(rowData).subscribe((res: any) => {
        });

        this.dataSource.data = this.dataSource.data.filter((value, key) => {
          if (value.ID_Abs == rowData.ID_Abs) {
            value.ID_Abs = rowData.ID_Abs;
            value.NodeAlias_Abs = rowData.NodeAlias_Abs;
            value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
            value.GPS_Long_Abs = rowData.GPS_Long_Abs;
            value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
            value.TestName_Abs = rowData.TestName_Abs;
          }
          return true;
        });
      }
    });

  }

  //Cancel editing node
  prevRowData: any;
  prevRowIndex = -1;
  UndoRow(rowData: any, rowIndex) {
    this.isEditable[rowIndex] = !this.isEditable[rowIndex];
    this.vqtID = 0;

    this.dataSource.data = this.dataSource.data.filter((value, key) => {
      if (value.ID_Abs == rowData.ID_Abs) {
        value.ID_Abs = rowData.ID_Abs;
        value.NodeAlias_Abs = rowData.NodeAlias_Abs;
        value.GPS_Lat_Abs = rowData.GPS_Lat_Abs;
        value.GPS_Long_Abs = rowData.GPS_Long_Abs;
        value.NodeIPAddr_Abs = rowData.NodeIPAddr_Abs;
        value.TestName_Abs = rowData.TestName_Abs;
      }
      return true;
    });

  }

  UpdateVQTData(rowData: any) {
    //debugger;
    //console.log(rowData)
    this.url = this.baseUrl + 'NwStat_VQT/UpdateNwStat_VQT';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, rowData, options);

  }
  UpdateOOSVQTData(rowData: any) {
    //debugger;

    this.url = this.baseUrl + 'NwStat_VQT/UpdateNwStatOOS_VQT';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };
    //var body = {
    //  PageNumber: this.commonFilter.PageNumber, PerPage: this.commonFilter.PerPage
    //}
    //return this.http.post<any>(this.url, "", { headers: headerOptions }); for post 3 agrument and for get 2 arguments // JSON.stringify({ commonFilter: this.commonFilter })
    return this.http.post<any>(this.url, rowData, options);

  }
}
 
